import { Component, Input, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-day-progress-view',
  templateUrl: './day-progress-view.component.html',
  styleUrls: ['./day-progress-view.component.scss'],
})
export class DayProgressViewComponent implements OnInit {

  @Input() coinImage;
  @Input() currentDay = 3;
  @Input() totalDays = 7;
  basePath = this.config.getConfig().CDN_BASEURL + "/assets/imgs/";
  public widthSize = 0;
  @Input() collects = [];


  constructor(private config: ConfigService) { }

  ngOnInit() {
    this.getWidthSize();
  }

  getWidthSize() {
    if (this.currentDay && this.totalDays) {
      this.widthSize = this.currentDay / this.totalDays * 100
    }
  }

}
